// extracted by mini-css-extract-plugin
export var btn = "Advantages-module--btn--8ce20";
export var btnOutlinePrimary = "Advantages-module--btn-outline-primary--c3f29";
export var btnPrimary = "Advantages-module--btn-primary--8f682";
export var card = "Advantages-module--card--e1174";
export var formSelect = "Advantages-module--form-select--390dd";
export var grid = "Advantages-module--grid--00113";
export var head = "Advantages-module--head--cad95";
export var heading = "Advantages-module--heading--9ec3f";
export var icon = "Advantages-module--icon--65f55";
export var inner = "Advantages-module--inner--5b03c";
export var intro = "Advantages-module--intro--e6d0a";
export var lead = "Advantages-module--lead--075d4";
export var note = "Advantages-module--note--60cc5";
export var section = "Advantages-module--section--f0d72";
export var text = "Advantages-module--text--1e6d0";
export var title = "Advantages-module--title--c46a0";